import React from "react";
import { Typography, TypographyProps } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import {PortTheme} from "~/ui/theme";


export type BorderedBox = TypographyProps & {
    children: any
};


const useStyles = makeStyles<PortTheme>(theme => ({
    root: {
        borderRadius: 4,
        borderStyle: "solid",
        borderColor: "#DADDE2",
        borderWidth: 1,
        display: "inline-flex",
        alignItems: "center",
        "& > *": {
            padding: "1px 5px",
            "&:not(:first-child)": {
                borderLeftStyle: "solid",
                borderLeftWidth: 1,
                borderColor: "inherit"
            }
        },
    },
}))


export const BorderedBox = (props: BorderedBox) => {
    const {children, ...other} = props;
    const classes = useStyles();

    return (
        <Typography component="span" className={classes.root} variant="cardTitle2" {...other}>
            {React.Children.map(props.children, (child, index) => (
                <span key={index}>
                    {child}
                </span>
            ))}
        </Typography>
    )
}